import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectOutletActivationResultComponent } from './select-outlet-activation-result.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { SelectOutletActivationResultRoutingModule } from './select-outlet-activation-result-routing.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [SelectOutletActivationResultComponent],
  imports: [
    CommonModule,
    SelectOutletActivationResultRoutingModule,
    TranslateModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  exports: [SelectOutletActivationResultComponent],
})
export class SelectOutletActivationResultModule {}
